export default "__VITE_ASSET__COOsoGid__"